import React from 'react';
import PropTypes from 'prop-types';
import PlaceholderComponent from "./PlaceholderComponent";
import Lazyload from 'react-lazyload';

class ProjectPhoto extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hover: false
        };

        this.onHover = this.onHover.bind(this);
        this.onHoverOff = this.onHoverOff.bind(this);
    }
    onHover(){
        this.setState({ hover: true });
    }

    onHoverOff(){
        this.setState({ hover: false });
    }
    render() {
        return (
            <div>
                <figure className="image has-margin-bottom-md wow fadeInUp fast"
                        onMouseEnter={this.onHover}
                        onMouseLeave={this.onHoverOff} >
                    <Lazyload height={400} offset={200} once placeholder={<PlaceholderComponent/>}>
                        <img src={this.props.url}
                         alt={this.props.alt}
                         title={this.props.alt}/>
                    </Lazyload>
                </figure>
                <p
                    className={`caption ${this.state.hover ? 'initial' : 'color-white' }`}>{this.props.alt}</p>
            </div>
        );
    }
}
ProjectPhoto.propTypes = {
    alt: PropTypes.string,
    url: PropTypes.string,
    caption: PropTypes.string
};

export default ProjectPhoto


// WEBPACK FOOTER //
// ./src/components/ProjectPhoto.js